module.exports = __webpack_public_path__ + "img/logo.9756bb8a.png";